import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MyAnalytics, PageTopButton } from '../atoms';
import { Footer } from '../components';
import {fetchUserMarkers, fetchUserDrawing, getDayReport, postPhotoToServer} from '../store/actions';
import { setLoginState, clearState } from '../store/actions';
import LogoImg from '../assets/img/logo.png';
import env from '../config/env';
import {Link} from "react-router-dom";
import LoginFilter from "../atoms/LoginFilter";
import loaderGif from "../assets/img/loader.gif";

const Camera = props => {
  const navigate = useNavigate();
	const dispatch = useDispatch();

	const login = useSelector(state => state.login)

	const token = login.userInfo.token;

	// aspect比が合わない不具合対応このサイトを参考
	// 参考：https://adiary.adiary.jp/0420
	// 目標は縦*横が150万
	const videoWidth  = 1250;
	const videoHeight = 1250;
	const offset      = (videoWidth - videoHeight)/2;

	const [isSending, setIsSending] = useState(false);
	const [capturedImage, setCapturedImage] = useState(null);
	const streamRef = React.useRef(null);

	// モバイルデバイスかどうかを動的に判定
	const isMobileDevice = () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		// iOS, Android, その他モバイルデバイスの判定
		const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
		// タッチポイントも確認（iPadOS対応）
		const hasTouch = navigator.maxTouchPoints > 0;
		return isMobile || (hasTouch && !/Macintosh/i.test(userAgent));
	};

  useEffect(()=>{
		const video = document.querySelector("#camera");

		// 動的にフロント/バックカメラを選択
		const useFrontCamera = !isMobileDevice();

		/** カメラ設定 */
		const constraints = {
			audio: false,
			video: {
			width: videoWidth,
			height: videoWidth,
			// フロントカメラとリアカメラで設定形式が異なるので注意
			// PC: フロントカメラ("user")、モバイル: バックカメラ({ exact: "environment" })
			facingMode: useFrontCamera ? "user" : { exact: "environment" }
			}
		};
	
		/**
		 * カメラを<video>と同期
		 */
		navigator.mediaDevices.getUserMedia(constraints)
		.then( (stream) => {
			streamRef.current = stream;
			video.srcObject = stream;
			video.onloadedmetadata = (e) => {
			video.play();
			};
		})
		.catch( (err) => {
			console.log(err.name + ": " + err.message);
		});
	}, [])

	const postPhoto = async (options) => {
		
		const response = await dispatch(postPhotoToServer(options))
		.then(res => {
			return res;
		}).catch(err => {

		});

		navigate("/manual_with_photo/"+response.photo_id+"/"+response.output_value)
		
		return response
	}
	
	
	const stopCamera = () => {
		if (streamRef.current) {
			streamRef.current.getTracks().forEach(track => track.stop());
			streamRef.current = null;
		}
		const video = document.querySelector("#camera");
		if (video) {
			video.srcObject = null;
		}
	};

	const takePicture = () => {

		const video = document.querySelector("#camera");

		// 実際のカメラ解像度を取得
		const actualWidth = video.videoWidth;
		const actualHeight = video.videoHeight;

		// 表示コンテナのサイズを取得
		const container = document.querySelector(".p-camera-content");
		const containerWidth = container.clientWidth;
		const containerHeight = container.clientHeight;

		// object-fit: cover のスケール計算
		const scaleX = containerWidth / actualWidth;
		const scaleY = containerHeight / actualHeight;
		const scale = Math.max(scaleX, scaleY);

		// マスク円の半径: 画面上150px（mask.svg r=150, background-size=1000px）
		// video座標系での円の半径
		const circleRadiusOnScreen = 150;
		const circleRadiusInVideo = circleRadiusOnScreen / scale;

		// object-fit:coverは映像を中央配置するため、円の中心は映像の中心
		const cropSize = circleRadiusInVideo * 2;
		const cropX = (actualWidth - cropSize) / 2;
		const cropY = (actualHeight - cropSize) / 2;

		var canvas = document.createElement("canvas")
		canvas.id = "canvas"
		canvas.width  = videoWidth;
		canvas.height = videoHeight;
		const context = canvas.getContext("2d");
		context.imageSmoothingQuality = 'high';

		// 円の内側をトリミングし、出力サイズに拡大
		context.drawImage(
			video,
			cropX, cropY, cropSize, cropSize,
			0,      0, videoWidth, videoHeight
		);

		const png = canvas.toDataURL("image/jpeg", 1.0)
		canvas.remove()

		// 撮影画像を保存し、カメラを停止し、送信中メッセージを表示
		setCapturedImage(png);
		stopCamera();
		setIsSending(true);

		const option = {
			method:"post",
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			png:png
		}

		// POST送信し、レスポンス後に画面遷移
		postPhoto(option)
	}
	
	
	

	return (
		<>
			
			<div className="l-wrap l-wrap--home">

			<LoginFilter />

			<header className="l-header">
				<div className="l-header__in">
					<ul className="p-head">
						<li className="p-head-l"><Link to={"/top"}><i className="icon icon-xmark"></i></Link></li>
						<li className="p-head-c">カメラ</li>
					</ul>
				</div>
			</header>

			{isSending ? (
				<div style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					padding: '20px',
					paddingTop: '74px',
					textAlign: 'center'
				}}>
					{capturedImage && (
						<img src={capturedImage} alt="撮影画像" style={{
							width: '100%',
							maxWidth: '320px',
							borderRadius: '8px',
							marginBottom: '20px'
						}} />
					)}
					<img src={loaderGif} alt="" style={{ width: '48px', marginBottom: '20px' }} />
					<p style={{ fontSize: 'calc(16px * var(--font-scale, 1))', color: '#333', lineHeight: '1.6' }}>
						撮影画像を送信しました。<br />
						処理完了後に自動的に画面が切り替わります
					</p>
				</div>
			) : (
				<>
					<div className="l-camera">

						<p className="p-camera-ttl"><span className="u-fs-11">尿が入った採尿カップの縁を枠線に合わせてください</span></p>

						<div className="p-camera-content">
							<div className="p-mask"></div>
							<div className="p-camera-red-circle"></div>
							<video id="camera" className="p-video" playsInline={true}></video>
						</div>

					</div>

					<div className="l-foot-btn __camera">
						<div className="l-foot-btn--in __camera">
							<div className="u-txt-c u-mb-xxs">
								<dl>
									<dt className="u-pb-1">
										<button type={"button"} className="c-btn-camera" onClick={() => {
											takePicture()
										}}><i className="icon icon-camera"></i></button>
									</dt>
									<dd><span>撮影</span></dd>
								</dl>
							</div>
						</div>
					</div>
				</>
			)}
			

			{/*/!* videoタグ側を正方形にしているのでこちらも合わせる *!/*/}
			{/*<div style={{width:"320px", height:"320px", position:"relative"}}>*/}
			{/*	<svg style={{position: "absolute",top: "50%", left: "50%", transform: "translate(-50%, -50%)", width:"100px",height:"100px"}}>*/}
			{/*		<circle cx="50" cy="50" r="50" fillOpacity="0" stroke="#FF0000" />*/}
			{/*	</svg>*/}
			{/*	*/}
			{/*</div>*/}


		</div>
		</>
	);
}

export default Camera;
